import { StoreUsersState } from '@/types';

export const SET_USERS = 'SET_USERS';

export default {
  [SET_USERS]: (state: StoreUsersState, payload: any) => {
    state.userList = payload;
  },
};
